import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { isMobile } from 'react-device-detect';
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Input,
  Button,
  DropdownTrigger,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Chip,
  Link,
  Pagination,
  MenuItem,
  Popover,
  PopoverTrigger,
  PopoverContent,
  Tooltip
} from "@nextui-org/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faAngleDown,
  faArrowAltCircleLeft,
  faArrowLeftLong,
  faArrowRightLong,
  faCircleXmark,
  faDownload,
  faFilter,
  faEllipsis,
  faMagnifyingGlass,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons"
import { format } from "date-fns"

import {
  exportToCSV,
  exportToExcel,
  exportToPDF,
  selectFilter,
} from "../Utility/utility.js"
import { ENUM_DASHBOARD_COLOR, ENUM_STATUS } from "../constants/enum.js"
import AdvancedFilter from "./AdvancedFilter.jsx";
import { useSelector } from "react-redux";

// const statusColorMap = {
//   active: "success",
//   paused: "danger",
//   vacation: "warning",
// }

const statusColorMap = {
  [ENUM_STATUS.Final]: "bg-green-400",
  [ENUM_STATUS.Pending]: "bg-red-400",
  [ENUM_STATUS.Return]: "bg-fuchsia-400",
  [ENUM_STATUS.PartialReturn]: "bg-red-400",
  [ENUM_STATUS.PartialFinal]: "bg-yellow-400",
  [ENUM_STATUS.Paid]: "bg-green-400",
  [ENUM_STATUS.PartPaid]: "bg-yellow-400",
}

const statusTextColorMap = {
  [ENUM_STATUS.Final]: "text-green-600",
  [ENUM_STATUS.Pending]: "text-red-600",
  [ENUM_STATUS.Return]: "text-fuchsia-600",
  [ENUM_STATUS.PartialReturn]: "text-red-600",
  [ENUM_STATUS.PartialFinal]: "text-yellow-600",
  [ENUM_STATUS.Paid]: "text-green-600",
  [ENUM_STATUS.PartPaid]: "text-yellow-600",
}
const statusLabelMap = {
  [ENUM_STATUS.Final]: "Final",
  [ENUM_STATUS.Pending]: "Pending",
  [ENUM_STATUS.Return]: "Return",
  [ENUM_STATUS.PartialReturn]: "Partial Return",
  [ENUM_STATUS.PartialFinal]: "Partial Final",
  [ENUM_STATUS.Paid]: "Paid",
  [ENUM_STATUS.PartPaid]: "Part Paid",
}
export const SELECTION_MODE = {
  none: "none",
  single: "single",
  multiple: "multiple",
}

export const COLUMN_TYPE = {
  date: "date",
  link: "link",
  multiline: "multiline",
  number: "number",
}

export const ROW_ACTION_BTN_TYPE = {
  link: "link",
}

export const TOP_ACTION_BTN_TYPE = {
  link: "link",
  dropdown: "dropdown",
}

export const FOOTER_TYPE = {
  link: "link",
  text: "text",
}

export const COLUMN_ALIGN_TYPE = {
  right: "right",
  left: "left",
  center: "ceter",
}

export default function NextUITable({
  INITIAL_VISIBLE_COLUMNS = [],
  data = [],
  columns = [],
  //newdata = [],
  id = "",
  handleDataChange,
  downloadFileName = "",
  exportColumns = [],
  topActionBtn = [],
  rowActionBtn = [],
  //rowInputBox=[],
  topActionFilter = [],
  rowSelection = false,
  downloadDataFooter = {},
  downloadFileHeader = {},
  exportReportType = "",
  selectionMode = SELECTION_MODE.multiple,
  showTopContent = true,
  showBottomContent = true,
  showPagination = true,
  showAdvanceFilter = true,
  onFilterChange,
  showFooter = true,
  advanceFilterParam = {},
  advFilterPageApiParam = {},
  advFilterVisibleField = [],
  handleSelectionChange = () => { },
  setData = () => { },

  // resetSelectedKeys=false,
}) {
  let index = 0

  const [filterValue, setFilterValue] = useState("")
  const [columnFilterValue, setColumnFilterValue] = React.useState("")
  const [selectedKeys, setSelectedKeys] = useState(new Set([]))
  const [visibleColumns] = useState(new Set(INITIAL_VISIBLE_COLUMNS))
  const [topFilter, setTopFilter] = useState({})
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [sortDescriptor, setSortDescriptor] = useState({})
  const [page, setPage] = useState(1)
  const pages = Math.ceil(data.length / rowsPerPage);
  const [temp, setTemp] = useState("")
  const{compName}=useSelector((state)=>state.company)

  if (page > pages && pages != 0) { //set page when search if no of pages less than all pages
    setPage(1);
  }
  const hasSearchFilter = Boolean(filterValue)
  const hasColumnFilter = Boolean(columnFilterValue)

  const headerColumns = useMemo(() => {
    if (visibleColumns === "all") return columns

    return columns.filter((column) =>
      Array.from(visibleColumns).includes(column.uid)
    )
  }, [visibleColumns, columns])

  function capitalize(str) {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1)
  }

  const filteredItems = useMemo(() => {
    let filteredData = [...data]

    if (hasSearchFilter) {
      let results = []

      for (let i = 0; i < data.length; i++) {
        for (let prop in data[i]) {
          if (
            data[i].hasOwnProperty(prop) &&
            data[i][prop]
              .toString()
              .toLowerCase()
              .includes(filterValue.toLowerCase())
          ) {
            results.push(data[i])
            break // Break to avoid duplicates
          }
        }
      }
      filteredData = results
    }

    // if (hasColumnFilter) {

    //   let result = filteredData.filter((data) => {
    //     const itemValue = data[columnFilterValue?.key];
    //     let itemType = typeof itemValue;
    //     return data[columnFilterValue?.key].toLowerCase().includes(columnFilterValue?.value.toString().toLowerCase())
    //   }

    //   )
    //   filteredData = result

    // }

    filteredData = selectFilter({
      data: filteredData,
      conditions: topFilter,
    })

    return filteredData
  }, [data, filterValue, columnFilterValue, hasColumnFilter, hasSearchFilter])

  const items = React.useMemo(() => {
    const start = (page - 1) * rowsPerPage
    const end = start + rowsPerPage

    if (showPagination)
      return filteredItems.slice(start, end)
    else
      return filteredItems;
  }, [page, filteredItems, rowsPerPage])

  //change total as filter data

  useEffect(() => {
    if (hasSearchFilter) {
      if (handleDataChange) {
        handleDataChange({ data: filteredItems, isFilter: true })
      }
    }
  }, [filteredItems])



  const sortedItems = React.useMemo(() => {
    return [...items].sort((a, b) => {
      const first = a[sortDescriptor.column]
      const second = b[sortDescriptor.column]
      const cmp = first < second ? -1 : first > second ? 1 : 0
      return sortDescriptor.direction === "descending" ? -cmp : cmp
    })
  }, [sortDescriptor, items])

  const renderCell = React.useCallback(
    (row, columnKey, column) => {
      let cellValue = row[columnKey]
      if (
        column?.hasOwnProperty("type") &&
        column.type === COLUMN_TYPE.number
      ) {
        let newValue = parseFloat(cellValue).toFixed(2)
        cellValue = newValue ? newValue : cellValue
      }

      if (column && column?.hasOwnProperty("secondCol")) {
        return (
          <div className="flex flex-col">
            <p className="text-bold text-small capitalize">{cellValue}</p>
            <p className="text-bold text-tiny capitalize  text-blue-500 flex flex-row items-center gap-0.5">
              {column?.secondCol?.icon}
              {row[column.secondCol.name]}
            </p>
          </div>
        )
      } else if (
        column?.hasOwnProperty("type") &&
        column.type === COLUMN_TYPE.date
      ) {
        return format(new Date(cellValue), "dd/MM/yyyy")
      } else if (
        column?.hasOwnProperty("type") &&
        column.type === COLUMN_TYPE.link
      ) {
        return (
          <Link
            href="#"
            color="primary"
            underline="hover"
            onPress={() => {
              column.onClick(row)
            }}
            className={"text-xs"}
          >
            {cellValue}
          </Link>
        )
      }
      switch (columnKey) {
        case "status":
        case "status":
          return (
            <Chip
              className={`capitalize border-none gap-1 
                bg-opacity-25 px-2 h-5
              ${statusColorMap[cellValue]}  
              ${statusTextColorMap[cellValue]}
               `}
              //color={"success"}
              size="sm"
              radius="sm"
              variant="flat"

            >
              {statusLabelMap[cellValue]}


            </Chip>
          )
        case "actions":
          return (
            <div className={`${column && column?.hasOwnProperty("align") ? "justify-center" : "justify-end"}  relative flex  items-center  gap-2`}>
              {rowActionBtn.map((btn, index) => {
                return (
                  <div key={index}>

                    <Button

                      size="sm"
                      variant="light"
                      onPress={() => {
                        btn.onClick(row)
                      }}
                      className={`px-0 min-w-0 ${btn && btn?.type === ROW_ACTION_BTN_TYPE.link
                        ? "text-black"
                        : "text-blue-500"
                        }`}
                    >
                      {btn.label}
                      {btn.icon}
                    </Button>

                  </div>
                )
              })}
            </div>
          )

        default:
          return cellValue
      }
    },
    [data.status, rowActionBtn]
  )

  const onRowsPerPageChange = React.useCallback((e) => {
    setRowsPerPage(Number(e.target.value))
    //setPage(1)
  }, [])

  const onSearchChange = React.useCallback((value) => {
    // setColumnFilterValue("")
    if (value) {
      setFilterValue(value)
      setPage(1)
    } else {
      setFilterValue("")
      if (handleDataChange)
        handleDataChange({ data: filteredItems, isFilter: false })

    }
  }, [])



  const addDataFooter = (tempData) => {
    let downloadDataFooter = {}
    if (Object.keys(downloadDataFooter).length > 0) {
      return [...tempData, downloadDataFooter]
    }
    return tempData
  }

  const downloadItems = [
    {
      labelName: "PDF",
      onClick: () => {
        exportToPDF({
          data: addDataFooter(data),
          downloadFileName: downloadFileName,
          downloadDataFooter: downloadDataFooter,
          exportReportType: exportReportType,
          exportColumns,
          companyName:compName,
          downloadFileheader: downloadFileHeader,
        })
      },
    },
    {
      labelName: "CSV",
      onClick: () => {
        exportToCSV({
          data: data,
          downloadFileName: downloadFileName,
          exportColumns,
        })
      },
    },
    {
      labelName: "EXCEL",
      onClick: () => {
        exportToExcel({
          data: data,
          downloadFileName: downloadFileName,
          exportColumns,
        })
      },
    },
  ]

  const onNextPage = useCallback(() => {
    if (page < pages) {
      setPage(page + 1)
    }
  }, [page, pages])

  const onPreviousPage = useCallback(() => {
    if (page > 1) {
      setPage(page - 1)
    }
  }, [page])

  const refWidth = useRef()
  const [cellWidths, setCellWidths] = useState([]);
  const [footerWidth, setFooterWidth] = useState(null);

  //sert width of footer 
  useEffect(() => {
    if (refWidth.current) {
      setFooterWidth(refWidth.current.offsetWidth)
      const table = refWidth.current;
      const cells = table.querySelectorAll('td, th');
      const widths = Array.from(cells).map(cell => (cell.offsetWidth));
      setCellWidths(widths);
    }
  }, [refWidth.current, INITIAL_VISIBLE_COLUMNS]);


  const handleColumnFilterChange = (e) => {
    setFilterValue("")
    const { value, name } = e.target

    if (value)
      setColumnFilterValue({ key: name, value: value })
    else
      setColumnFilterValue("")
  }
  const [selAdvancedFilter, setSelAdvancedFilter] = useState()
  const handleApplyFilters = (filterValues) => {
    //setIsScrolling("hi")
    setSelAdvancedFilter(filterValues);
    // closeDrawer();
    if (onFilterChange) {
      onFilterChange(filterValues); // send to parent page
    }
  };
  const topContent = React.useMemo(() => {
    return (
      <div className="flex flex-col gap-1">
        <div className="flex flex-col gap-2  ">
          <div className="flex justify-between gap-2  items-end">
            <div className="flex justify-between gap-2  items-end">
              <Input
                isClearable
                classNames={{
                  base: "sm:max-w-[100%]",
                  // base: "sm:max-w-[44%]",
                  inputWrapper: "border-1 border-rose-200",
                }}
                placeholder="Search..."
                size="md"
                startContent={<FontAwesomeIcon icon={faMagnifyingGlass} className="text-rose-400 px-5" />}
                value={filterValue}
                color={"danger"}
                variant="underlined"
                onClear={() => setFilterValue("")}
                onValueChange={onSearchChange}
              />
              {showAdvanceFilter ?
                // <Tooltip content="filter">
                <div className="flex gap-2">
                  <Popover
                    //onOpenChange={handlePopOverOpenChange}
                    shouldCloseOnBlur={false}
                    disableAnimation={false}
                    shouldBlockScroll={true}

                    placement={"bottom-start"} showArrow={false} color="default" className="" radius="none" variant="bordered"
                  >
                    <PopoverTrigger>

                      <Button isIconOnly={true}
                        size="sm" color="primary" variant="light"
                        // onPress={() => setIsPopoverOpen((prev) => !prev)} // manual toggle
                        className="bg-sky-200  text-md border-0 border-orange-500 text-sky-600 px-2"
                      >
                        <FontAwesomeIcon icon={faFilter}></FontAwesomeIcon>

                      </Button>
                    </PopoverTrigger>
                    <PopoverContent className={`p-1  `}>
                      {/* ${isMobile ? 'w-full' : 'w-9/12'} */}
                      <div className="p-2 ">
                        <h4 className="bg-sky-50 text-sky-700 p-2 border-1 border-sky-50 mb-2 font-semibold" >Advance Filter</h4>
                        <AdvancedFilter visibleFilterField={advFilterVisibleField}
                          apiParam={advFilterPageApiParam} selFilter={advanceFilterParam}
                          onApply={handleApplyFilters}
                        />
                      </div>
                    </PopoverContent>
                  </Popover>
                  {advanceFilterParam && Object.keys(advanceFilterParam).length > 0 ?
                    <Chip size="sm" variant="flat" color="danger">
                      <FontAwesomeIcon onClick={() => handleApplyFilters({})} className="cursor-pointer" icon={faXmarkCircle}></FontAwesomeIcon>
                      Clear Filters</Chip> : ""}
                </div> : ""}
            </div>
            <div className="flex  gap-2 ">
              {/* topActionBtn */}
              {topActionBtn.map((item, index) => {
                return (
                  <div key={index}>
                    {item.isShowOnSelection ? (
                      <Button
                        color="primary"
                        // className="bg-foreground text-background"
                        endContent={item.icon}
                        size="sm"
                        isDisabled={
                          !(selectedKeys.size > 0 || selectedKeys === "all")
                        }
                        onPress={() => {
                          item.onClick({ selectedKeys: selectedKeys })
                        }}
                      >
                        {item.label}
                      </Button>
                    ) : (
                      <Button
                        color="primary"
                        endContent={item.icon}
                        size="sm"
                        onPress={item.onClick}
                      >
                        {item.label}
                      </Button>
                    )}
                  </div>
                )
              })}
              {/* end of topActionBtn */}
              {/* download */}
              <Dropdown>
                <DropdownTrigger className="flex">
                  <Button
                    color="warning"
                    endContent={<FontAwesomeIcon icon={faAngleDown} />}
                    size="sm"
                    variant="flat"
                  >
                    Export <FontAwesomeIcon icon={faDownload} />
                  </Button>
                </DropdownTrigger>
                <DropdownMenu
                  color="primary"
                  disallowEmptySelection
                  aria-label="download"
                  closeOnSelect={true}
                  selectionMode="single"
                >
                  {downloadItems.map((item, index) => (
                    <DropdownItem
                      key={index}
                      className="capitalize"
                      onPress={item.onClick}
                    >
                      {capitalize(item.labelName)}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
              {/* end of download  */}
            </div>
          </div>
          <div className="flex gap-2 justify-start flex-wrap">
            {/* topActionFilter */}
            {topActionFilter.map((item, index) => {
              return (
                <div key={index}>
                  <Dropdown>
                    <DropdownTrigger>
                      <Button endContent={item.icon} size="sm" color="primary">
                        {item.label}
                      </Button>
                    </DropdownTrigger>
                    <DropdownMenu
                      disallowEmptySelection
                      aria-label="Table Columns"
                      closeOnSelect={false}
                      selectionMode="single"
                      onSelectionChange={(e) => {
                        let val = e && e?.size > 0 ? Array.from(e)[0] : null
                        if (val === "clear") {
                          // const { [item.uid], ...newState } = state
                          setTopFilter((perv) => {
                            // Create a copy of the previous state
                            const newState = { ...perv }
                            // Remove the specified key
                            delete newState[item.uid]
                            // Return the updated state
                            return newState
                          })
                        } else if (val) {
                          setTopFilter((prev) => ({
                            ...prev,
                            [item.uid]: val,
                          }))
                        }
                      }}
                    >
                      {/* clear filter */}
                      <DropdownItem key={"clear"} color="warning">
                        <span className="capitalize flex gap-2  items-center">
                          {capitalize("clear")}
                          <FontAwesomeIcon icon={faCircleXmark} />
                        </span>
                      </DropdownItem>
                      {/* end of clear filter */}

                      {item?.data?.map((value) => (
                        <DropdownItem key={value} className="capitalize">
                          {capitalize(value)}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              )
            })}
            {/* end of topActionFilter */}
          </div>
        </div>
        {showPagination ? (
          <div className="flex justify-between items-center text-xs font-semibold shadow bg-g7ray-50">
            <span className="text-gray-700 text-small">
              Total {data.length} records
            </span>
            <label className="flex items-center text-slate-700 text-small">
              Rows per page:
              {/* custom-bg-light */}
              <select
                className="bg-white  outline-none  p-1 ml-2 text-custom-bg-light text-sm"
                onChange={onRowsPerPageChange}
              >
                <option value="25">25</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
              </select>
            </label>
          </div>
        ) : ""}
      </div>
    )
  }, [
    topActionBtn,
    filterValue,
    onSearchChange,
    onRowsPerPageChange,
    data.length,
    selectedKeys,
    handleDataChange ? handleDataChange : ""
  ])

  const bottomContent = React.useMemo(() => {
    return (

      <div className={showPagination ? "py-0 px-0" : ""}>
        {/* footer */}
        {showFooter ? (
          <table className="mb-2 bg-custom-text-primary   " width={footerWidth ? footerWidth : ""}>
            <thead className="bg-custom-text-primary ">
              <tr>
                {INITIAL_VISIBLE_COLUMNS.map((visibleCol, i) => {
                  const column = columns.find((row) => row.uid === visibleCol)

                  return (
                    <>
                      {rowSelection && i == 0 ? <th key={i}
                        width={cellWidths ? Math.round((cellWidths[i] * 6 / 100)) + "%" : ""}></th> : ""}
                      <th
                        key={i}
                        width={cellWidths ? Math.round((cellWidths[i] * 6 / 100)) + "%" : ""}
                        className={`whitespace-normal text-xs text-white  pt-2   uppercase font-normal   align-top  ${column &&
                          column?.hasOwnProperty("align") &&
                          column.align === COLUMN_ALIGN_TYPE.right
                          ? "text-right" : column.align === COLUMN_ALIGN_TYPE.center ? "text-center"
                            : ""
                          }
                       
                        ${i == 0 ? "pl-4" : ""}
                       
                      `}
                      >

                        {column &&
                          column?.uid.toLowerCase() == "actions" || column?.uid.toLowerCase() == "menuactions" ? "-" :
                          column?.name}


                      </th>
                    </>

                  )
                })}
              </tr>
            </thead>
            <tbody className="overflow-h-scroll">
              <tr>
                {INITIAL_VISIBLE_COLUMNS.map((visibleCol, i) => {
                  const column = columns.find((row) => row.uid === visibleCol)
                  return (
                    <>
                      {rowSelection && i == 0 ? <td className="" key={i}
                        width={cellWidths ? Math.round((cellWidths[i] * 6 / 100)) + "%" : ""}></td> : ""}

                      <td
                        key={i}
                        //width={Math.round((cellWidths[i] * 6 / 100)) + "%"}
                        className={`bg-custom-text-primary whitespace-normal text-custom-text-white text-xs pb-2   `}
                      >
                        {column?.hasOwnProperty("footer") ? (
                          <div
                            // width={Math.round((cellWidths[i] * 6 / 100)) + "%"}
                            className={` w-full 
                        ${column?.footer?.type === FOOTER_TYPE.link
                                ? " flex justify-end "
                                : "text"
                              }"`}
                          >
                            {column?.footer?.type === FOOTER_TYPE.text ? (
                              <div
                                className={`align-top   ${column &&
                                  column?.hasOwnProperty("align") &&
                                  column.align === COLUMN_ALIGN_TYPE.right
                                  ? "text-right" : column.align === COLUMN_ALIGN_TYPE.center ? "text-center"
                                    : ""
                                  } 
                                ${i == 0 ? "pl-4" : ""}
                                `}
                              >
                                {column?.footer?.label} {column?.footer?.value}
                              </div>
                            ) : (
                              <Button
                                size="sm"
                                onPress={column?.footer?.onClick}
                                className={`text-black `}
                                variant="light"
                              >
                                {column?.footer?.label}
                                {column?.footer?.icon}
                              </Button>
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                    </>
                  )
                })}
              </tr>
            </tbody>

          </table>) : ""}
        {/* end of footer */}
        {showPagination ? (
          <div className="py-2 px-2 flex justify-center  flex-wrap gap-2 items-end">
            <div className={` ${isMobile ? "justify-end" : "justify-between"} flex  flex-wrap  w-full`}>
              <div>
                <Pagination
                  size="sm"
                  isCompact
                  showControls
                  showShadow
                  color="primary"
                  radius="none"
                  page={page}
                  total={pages}
                  onChange={setPage}
                  classNames={{
                    prev: "bg-sky-100 text-sky-700 font-bold  text-2xl",
                    next: "bg-sky-100 text-sky-700 font-bold  text-2xl",
                    item: "text-xs  h-7 bg-white font-bold text-sky-700 m-1 border-1 border-sky-100  rounded-full",
                    wrapper: ""
                  }}
                  //onChange={setPage;isCutomeSearch=false}
                  className="text-xs"
                />
              </div>
              <div className="flex    flex-end gap-2 text-xs">
                <Button
                  isDisabled={pages === 1}
                  size="sm"

                  color="primary"
                  variant="flat"
                  onPress={onPreviousPage}
                  startContent={<FontAwesomeIcon icon={faArrowLeftLong} />}


                >
                  Prev.
                </Button>
                <Button
                  isDisabled={pages === 1}
                  size="sm"
                  color="primary"
                  variant="flat"
                  onPress={onNextPage}
                  endContent={<FontAwesomeIcon icon={faArrowRightLong} />}
                >
                  Next
                </Button>
              </div>
              {/* <span className="w-[30%] text-xs text-default-400 ">
                {selectedKeys === "all"
                  ? "All items selected"
                  : `${selectedKeys.size} of ${filteredItems.length} selected`}
              </span>  30%*/}
            </div>


          </div>
        ) : ""}
      </div>
    )
  }, [
    selectedKeys,
    items.length,
    page,
    pages,
    hasSearchFilter,
    INITIAL_VISIBLE_COLUMNS,
    columns,
    cellWidths
  ])

  const classNames = React.useMemo(

    () => ({

      base: !showPagination && data && data.length > 8 ? "max-h-[300px] overflow-scroll" : "",
      table: !showBottomContent && data && data.length > 8 ? "min-h-1" : "",
      wrapper: showPagination ? ["max-h-[382px]", "max-w-3xl", "overflow-hidden"] : [],
      th: ["py-2", "h-auto", "bg-custom-text-primary ", "font-normal", "uppercase", "text-white", "rounded-none",
        // changing the rows border radius
        // first
        "group-data-[first=false]:first:before:bg-red-700",
        "group-data-[first=false]:last:before:bg-red-700",
        // middle
        "group-data-[middle=true]:before:rounded-none",
        // last
        "group-data-[last=true]:first:before:rounded-none",
        "group-data-[last=true]:last:before:rounded-none",

      ],
      tbody: ["overflow-h-scroll border-1 border-sky-100"],
      tr: ["hover:bg-custom-color-hover", "hover:text-custom-bg-light", "rounded-none", "m-0",
        "even:bg-custom-color-even", "odd:bg-custom-color-odd"],
      td: [
        "p-1",
        // changing the rows border radius
        // first
        "group-data-[first=true]:first:before:rounded-none",
        "group-data-[first=true]:last:before:rounded-none",
        // middle
        "group-data-[middle=true]:before:rounded-none",
        // last
        "group-data-[last=true]:first:before:rounded-none",
        "group-data-[last=true]:last:before:rounded-none",
        "text-sm",
      ],
    }),
    [data]
  )
  //className={isMobile?" overflow-x-auto":""}
  return (
    <div className={isMobile ? " overflow-x-auto" : ""}>
      <Table
        ref={refWidth}
        color="primary"
        className="m-0 gap-1"
        isHeaderSticky
        isCompact
        // radius="none"
        removeWrapper
        selectionBehavior={rowSelection ? "toggle" : "replace"}
        aria-label="Example table with custom cells, pagination and sorting"
        bottomContent={showBottomContent ? bottomContent : null}
        bottomContentPlacement="outside"
        checkboxesProps={{
          classNames: {
            wrapper:
              //"after:bg-rose-500 after:text-background text-background ",
              "after:bg-custom-text-primary after:text-background text-background",
          },
        }}
        classNames={classNames}
        selectedKeys={selectedKeys}
        selectionMode={selectionMode}
        sortDescriptor={sortDescriptor}
        topContent={showTopContent ? topContent : null}
        topContentPlacement="outside"

        onSelectionChange={(e) => {
          setSelectedKeys(e)
          handleSelectionChange({ e, column: id, setData })
        }}
        onSortChange={setSortDescriptor}
      >
        <TableHeader columns={headerColumns}   >
          {(column, index) => (

            <TableColumn
              className={`whitespace-normal mx-auto align-top align   ${column &&
                column?.hasOwnProperty("align") &&
                column.align === COLUMN_ALIGN_TYPE.right
                ? "text-right" : column.align === COLUMN_ALIGN_TYPE.center ? "text-center"
                  : ""
                }`}
              key={column.uid || index}
              align={column.uid === "actions" ? "center" : "start"}
              allowsSorting={column.sortable}

            >
              {column.name}

              {column && column?.hasOwnProperty("filter") && column?.filter == true ?
                <input type="text"
                  className="rounded-none mt-2" value={columnFilterValue?.value}
                  name={column.uid} size="sm"
                  onChange={handleColumnFilterChange}  ></input>
                : ""}
            </TableColumn>

          )}

        </TableHeader>
        <TableBody emptyContent={"No data found"} items={sortedItems}>
          {(item, i) => {
            index = index + 1
            return (
              // <>
              <TableRow
                key={item[id] || index}>
                {(columnKey) => {
                  const column = columns.find((row) => row.uid === columnKey)

                  return (
                    <TableCell style={{
                      ...(column &&
                          column?.hasOwnProperty("isLineBreak")&&column?.isLineBreak === true && {
                        overflowWrap: "break-word",
                        wordBreak: "break-all"
                      })
                    }}
                      className={`  text-xs
                        ${column &&
                          column?.hasOwnProperty("align") &&
                          column.align === COLUMN_ALIGN_TYPE.right
                          ? "text-right" : column.align === COLUMN_ALIGN_TYPE.center ? "text-center"
                            : "text-left"
                        } ${column?.hasOwnProperty("textcolor") &&
                          column.textcolor === ENUM_DASHBOARD_COLOR.jobWork
                          ? "text-custom-text-color-jobwork" : column.textcolor === ENUM_DASHBOARD_COLOR.Month
                            ? "text-custom-text-color-month" : column.textcolor === ENUM_DASHBOARD_COLOR.Party
                              ? "text-custom-text-color-party" : column.textcolor === ENUM_DASHBOARD_COLOR.Product
                                ? "text-custom-text-color-product" : column.textcolor == ENUM_DASHBOARD_COLOR.Comb_MonthYear
                                  ? "text-custom-text-color-monthyear" : column.textcolor == ENUM_DASHBOARD_COLOR.Comb_Payable
                                    ? "text-custom-text-color-payable" : column.textcolor == ENUM_DASHBOARD_COLOR.Comb_Receivable
                                      ? "text-custom-text-color-receivable" : column.textcolor == ENUM_DASHBOARD_COLOR.Comb_Difference
                                        ? item[columnKey] < 0 ? "text-custom-text-color-diff_minus" : "text-custom-text-color-difference" : ""}`}
                    >
                      {renderCell(item, columnKey, column)}
                      {/* {columnKey != "inputs"?
                      renderCell(item, columnKey, column)
                      : (<Input type="text" onChange={(e)=>{ console.log(e); setTemp(e.target.value)}} ></Input>)} */}
                    </TableCell>

                  )

                }}
              </TableRow>

            )
          }}

        </TableBody>
      </Table>
    </div>
  )
}
